<template>
	<div
		class="flow-file-upload"
		:state="state"
		@click="handleClick"
		@drop.prevent="dropFile"
		@dragover.prevent
	>
		<div class="flow-file-upload-title-container">
			<p v-if="title" class="paragraph-2 fc-dark">
				{{ title }}
			</p>
			<p v-if="subTitle" class="paragraph-2 fc-light">
				{{ subTitle }}
			</p>
		</div>
		<Icon name="i-upload" type="filled" />
		<input ref="fileInput" :accept="accept" type="file" @input="selectFile" />
	</div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
import Icon from "./../Icon/Icon.vue";

export default defineComponent({
	name: "FileUpload",
	components: {
		Icon
	},
	props: {
		/**
		 * title of file uploader inside the inputbox
		 */
		title: {
			type: String,
			default: null
		},
		/**
		 * sub title of file upload (mostly file extention)
		 */
		subTitle: {
			type: String,
			default: null
		},
		accept: {
			type: String,
			default: "*/*"
		},
		/**
		 * 'default' | 'error'
		 */
		state: {
			type: String,
			default: "default"
		}
	},
	methods: {
		handleClick() {
			const fileInput = this.$refs.fileInput as HTMLInputElement;
			fileInput.value = "";
			fileInput.click();
		},

		dropFile(e: DragEvent) {
			const files = e.dataTransfer?.files;
			const filesArr = files ? Array.from(files) : [];

			/**
			 * Whenever File is selected.
			 *
			 * @event onFileSelect
			 */
			this.$emit("onFileSelect", filesArr);
			/**
			 * Whenever Files are  changed.
			 *
			 * @event change
			 */
			this.$emit("change", filesArr);
			/**
			 * input event for validation
			 *
			 * @event input
			 */
			this.$emit("input", filesArr);
		},

		selectFile() {
			const fileInput = this.$refs.fileInput as HTMLInputElement;
			const files = fileInput.files;
			const filesArr = files ? Array.from(files) : [];

			this.$emit("onFileSelect", filesArr);
			this.$emit("change", filesArr);
			this.$emit("input", filesArr);
		}
	}
});
</script>
<style lang="scss">
$state-colors: (
	"default": "",
	"error": var(--dashboard-danger)
);
div.flow-file-upload {
	display: flex;
	border: 2px dashed var(--slideout-border);
	background-color: var(--slideout-input);
	padding: 16px;
	justify-content: space-between;
	align-items: center;
	border-radius: 4px;
	cursor: pointer;

	> div.flow-file-upload-title-container {
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	> input[type="file"] {
		display: none;
	}

	@each $state, $color in $state-colors {
		&[state="#{$state}"] {
			box-shadow: 0 0 0 1px $color;
		}
	}
}
</style>
